import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, margins, paddings, sizes } from '@shared/port-v1.0.0'

export type Props = BaseReactProps & {}

import Comp from '../component'

export default {
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({
				name: 'shadow',
				displayName: 'Shadow',
				group: 'Styles',
				type: [{ value: '0', label: 'none' }, ...sizes],
				default: 'sm',
			}),
			getPortDef({
				name: 'radius',
				displayName: 'Radius',
				group: 'Styles',
				type: [{ value: '0', label: 'none' }, ...sizes],
				default: 'md',
			}),
			getPortDef({ name: 'withBorder', displayName: 'With border', group: 'Styles', type: 'boolean', default: false }),
			getPortDef({ name: 'opacity', displayName: 'Opacity', group: 'Styles', type: 'number', default: 1 }),
			getPortDef({ name: 'w', displayName: 'Width', group: 'Dimensions', type: 'string' }),
			getPortDef({ name: 'h', displayName: 'Height', group: 'Dimensions', type: 'string' }),
			...margins,
			...paddings,
		],
	},
} satisfies ReactNodeDef
